import styled from 'styled-components'
import { Checkbox } from 'antd'

export const StyledCloseIcon = styled.span`
  // background: #e5ebff;
  color: ${({ theme }) => theme.colors.primary};
  top: 10px;
  right: 10px;
  border-radius: 5px;
  padding: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 300;
  transition: transform 0.3s ease-in-out;

  &:hover {
    background: #e5ebff;
    transform: rotate(90deg);
  }
`

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
  }
  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }
`

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }
`
